import { Component } from '@angular/core';

import { onMainContentChange } from 'src/app/core/animations/animations-menu';
import { MenuService } from 'src/app/core/services/menu/menu.service';

@Component({
    selector: 'app-admin-layout',
    templateUrl: './admin-layout.component.html',
    styleUrls: ['./admin-layout.component.scss'],
    animations: [onMainContentChange],
})
export class AdminLayoutComponent {
    public onSideNavChange!: boolean;
    leftSidenav!: boolean;
    constructor(private _sidenavService: MenuService) {
        this._sidenavService.sideNavState$.subscribe((res: boolean) => {
            this.onSideNavChange = res;
            this.leftSidenav = res;
        });
    }
}
